export const skills = {
  Web: [
    { name: "React", percent: 90 },
    { name: "Node JS", percent: 80 },
    { name: "Express JS", percent: 90 },
    { name: "JavaScript", percent: 80 },
    { name: "MongoDB", percent: 95 },
    { name: "Redux", percent: 70 },
    { name: 'CSS', percent: 80 }
  ],
  Programming: [
    { name: "JavaScript", percent: 90 },
    { name: 'Python', percent: 80 },
    { name: 'C', percent: 80 }
  ],
  Tools: [
    { name: 'VS Code', percent: 95 },
    { name: "Git", percent: 95 },
    { name: "Postman", percent: 100 },
    { name: "Vercel", percent: 100 },
    { name: "Render", percent: 100 },
    { name: "MongoDB Atlas", percent: 100 },
  ],
};